import styled from "styled-components";

export const NoPlansAvailableText = styled.p`
  font-size: 0.95em;
  font-weight: 500;
  padding: 25px 0 50px 0;
  color: #7d7d7d;
  display: block;
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
`;
